export const environment = {
  // Server_URL: 'http://127.0.0.1:8000/api'
  Server_URL: 'https://backendtest.blueboxpet.com/api',
  // Server_URL: 'https://backendtesting.blueboxpet.com/api',
};
